const KEY = "hf_cookie_consent";

export const getConsent = () => { try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; } };

export const setConsent = choice => {
  localStorage.setItem(KEY, JSON.stringify({ choice, at: new Date().toISOString(), v: 1 }));
  const ph = window.posthog;
  if (!ph?.opt_in_capturing) return;
  if (choice === "accepted") {
    ph.set_config?.({ persistence: "localStorage+cookie", disable_session_recording: false });
    ph.opt_in_capturing(); ph.startSessionRecording?.();
  } else {
    ph.stopSessionRecording?.(); ph.opt_out_capturing(); ph.reset?.(); ph.set_config?.({ persistence: "memory", disable_session_recording: true });
    Object.keys(localStorage).filter(k => k.startsWith("ph_") || k.startsWith("__ph")).forEach(k => localStorage.removeItem(k));
    Object.keys(sessionStorage).filter(k => k.startsWith("ph_") || k.startsWith("__ph")).forEach(k => sessionStorage.removeItem(k));
    const host = window.location.hostname, parts = host.split(".");
    const domains = ["", host, ...parts.map((_, i) => "." + parts.slice(i).join(".")).filter(d => d.split(".").length > 2)];
    document.cookie.split(";").map(c => c.split("=")[0].trim()).filter(n => n.startsWith("ph_")).forEach(n =>
      domains.forEach(d => { document.cookie = `${n}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${d ? `; domain=${d}` : ""}`; }));
  }
  window.dispatchEvent(new Event("hf-consent"));
};
